module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/icon-woman-7c4be6493f6d8cda979d9a3bdf7ac661.png";